import { apiClient } from "./apiClient";

export interface User {
  id: string;
  email: string;
  name: string | null;
  role: "admin" | "user";
  status: "active" | "disabled";
  oauth_provider: string | null;
  oauth_id: string | null;
  phone: string | null;
  country: string | null;
  city: string | null;
  address: string | null;
  profile_completed: boolean;
  created_at: string;
  updated_at: string;
  last_login: string | null;
}

export interface CreateUserRequest {
  email: string;
  name?: string;
  role?: "admin" | "user";
  status?: "active" | "disabled";
}

export interface UpdateStatusRequest {
  status: "active" | "disabled";
}

export interface UpdateRoleRequest {
  role: "admin" | "user";
}

export async function listUsers(skip = 0, limit = 100): Promise<User[]> {
  const response = await apiClient.get<User[]>("/admin/users", {
    params: { skip, limit },
  });
  return response.data;
}

export async function createUser(user: CreateUserRequest): Promise<User> {
  const response = await apiClient.post<User>("/admin/users", user);
  return response.data;
}

export async function updateUserStatus(
  userId: string,
  status: "active" | "disabled"
): Promise<User> {
  const response = await apiClient.patch<User>(
    `/admin/users/${userId}/status`,
    { status }
  );
  return response.data;
}

export async function updateUserRole(
  userId: string,
  role: "admin" | "user"
): Promise<User> {
  const response = await apiClient.patch<User>(`/admin/users/${userId}/role`, {
    role,
  });
  return response.data;
}

